export default __webpack_public_path__ + "static/media/man-user-1.ab17cc70.svg";